import { INIT_INQUIRY, REQUEST_INQUIRY, RECEIVE_EXTENSIONS_WHITE_LIST, REQUEST_EXTENSIONS_WHITE_LIST } from '../actions/a.inquiry-form'

import Store from '../store'

const Inquiry = (state = Store.Inquiry, action) => {
    switch (action.type) {
        case REQUEST_INQUIRY:
            return {
                ...state,
                isFetching: true,
            }
        case INIT_INQUIRY:
            return {
                ...state,
                isFetching: false,
            }
        case REQUEST_EXTENSIONS_WHITE_LIST:
            return {
                ...state,
                isFetching: true,
            }
        case RECEIVE_EXTENSIONS_WHITE_LIST:
            return {
                ...state,
                userId: action.payload.UserID,
                isAuthenticated: action.payload.IsAuthenticated,
                firstName: action.payload.FirstName,
                lastName: action.payload.LastName,
                mobile: action.payload.Mobile,
                allowedExtensions: action.payload.AllowedExtensions,
                suggestedTags: action.payload.SuggestedTags,
                allTags: action.payload.AllTags,
                isFetching: false,
            }
        default:
            return state
    }
}

export default Inquiry